/* Общее хранилище личных настроек пользователя во фронте — единый источник для ВСЕХ
   потребителей (порядок рельса сегодня, тема/язык/часовой пояс завтра): один GET /api/prefs
   на сессию, дальше только память (владелец, доработка T-CORE-USERPREFS: «запрос, кеш, и
   пока не будет изменений — кеш»). Новый ключ = новый потребитель через getPrefSync/setPref,
   этот файл больше не трогается. */
import { apiFetch } from "../api/client";
let cache = null;
let inFlight = null;
// dirty — ключи, чья последняя запись на сервер не удалась: значение в памяти актуально для
// текущей вкладки, но не гарантированно переживёт перезагрузку — потребитель решает, как это
// честно показать (напр. индикатор «не сохранено»), молча терять изменение нельзя.
const dirty = new Set();
// loadAllPrefs — источник истины, один запрос на сессию: повторные вызовы отдают уже
// загруженный кеш без похода в сеть, пока resetPrefsCache не сбросит его явно. Недоступность
// сервера не бросает исключение — пустая карта, потребители получают undefined на свои ключи
// (тот же результат, что при отсутствии сохранённой настройки).
export async function loadAllPrefs() {
    if (cache)
        return cache;
    if (!inFlight) {
        inFlight = apiFetch("/api/prefs")
            .then((res) => {
            cache = res.values ?? {};
            return cache;
        })
            .catch(() => {
            cache = {};
            return cache;
        })
            .finally(() => { inFlight = null; });
    }
    return inFlight;
}
// getPrefSync — синхронное чтение уже загруженного кеша (для рендера после loadAllPrefs),
// сеть не трогает; undefined до первой загрузки или для отсутствующего ключа.
export function getPrefSync(key) {
    return cache?.[key];
}
// isPrefDirty — true, если последняя запись ключа на сервер провалилась.
export function isPrefDirty(key) {
    return dirty.has(key);
}
// setPref — память обновляется НЕМЕДЛЕННО (интерфейс не ждёт сервера), запись уходит в фоне;
// провал не роняет оболочку, но помечает ключ dirty вместо молчаливой потери изменения.
export function setPref(key, value) {
    cache = { ...(cache ?? {}), [key]: value };
    apiFetch("/api/prefs", { method: "PUT", body: { key, value } })
        .then(() => { dirty.delete(key); })
        .catch(() => { dirty.add(key); });
}
// resetPrefsCache — сбросить кеш на logout/смену пользователя: иначе следующий loadAllPrefs
// вернул бы из памяти настройки уже вышедшего аккаунта.
export function resetPrefsCache() {
    cache = null;
    inFlight = null;
    dirty.clear();
}
